import React, { useState } from 'react'
import CompteBeneficiaires from '../../../../model/entities/compte-beneficiaires'
import { Container, Modal } from 'semantic-ui-react'
import { PaginatedTable } from '../../../generic/paginated-table/paginated-table'
import { StatutCompteBeneficiaires } from '../../../../model/entities/statut-compte-beneficiaires'
import { SimpleButton } from '../../../generic/simple-button'
import { LoadingSpinner } from '../../../generic/loading-spinner'
import { StatutSca } from '../../../../model/entities/statut-sca'
import CreateCompteBeneficiairesForm from '../../../investment/create-compte-beneficiaires-form'

type Props = {
    accounts?: CompteBeneficiaires [],
    userScaStatus?: string
}
export default function CompteBeneficiairesPane({accounts, userScaStatus}: Props) {
    const [isEdited, setIsEdited] = useState(false)
    console.log('userScaStatus :>> ', userScaStatus);
    const mappingStatut = [
        {
            code:StatutCompteBeneficiaires.VERIFICATION_EN_ATTENTE,
            message: 'Vérification en attente'
        },
        {
            code: StatutCompteBeneficiaires.ANNULE,
            message: 'En échec'
        },
        {
            code: StatutCompteBeneficiaires.VALIDE,
            message: 'Validé'
        },
        {
            code: StatutCompteBeneficiaires.DESACTIVE,
            message: 'Désactivé'
        }
    ]  



    return (
    <Container>
        <h1 style={{paddingTop: '2rem', paddingBottom:'2rem', fontSize:'1.875rem', lineHeight:'2.25rem'}}>Mes comptes bancaires</h1>
         <LoadingSpinner height={100} />
        {accounts?.length ? 
            <PaginatedTable
            elements={accounts}
            elementsPerPage={5}
            headers={
                [
                    'Nom du compte',
                    'Iban',
                    'Statut du compte'
                ]
            }
            columnSelector={(element: CompteBeneficiaires) => {
                return {
                    values: [
                        element.Name ? element.Name : '',
                        element.Iban ? element.Iban : '',
                        mappingStatut.find(s => s.code === element.StatusCode)?.message
                    ]
                }
            }}
            />
            :
            <div className="text-center p-8 text-xl">
                    <span className="font-bold">
                        Vous n'avez pas encore enregistré de compte bancaire.
                    </span>
            </div> 
        }
        { userScaStatus === StatutSca.VALIDE && 
        <div className="text-center py-8">
            <SimpleButton
                onClick={() => {
                setIsEdited(true);
                }}
                label='Ajouter un compte'
            />
        </div>  
        } 
        <Modal  onClose={() => setIsEdited(false)} open={isEdited}>
        <Modal.Header>Ajouter un compte bancaire</Modal.Header>
        <Modal.Content>
            <Modal.Description>
            <CreateCompteBeneficiairesForm
                onSkipAction={() => setIsEdited(false)}
            />
            </Modal.Description>
        </Modal.Content>
        </Modal>  
    </Container>
    )
}
